export default function Menus() {
  return <div className="p-6 text-2xl">Menus Screen</div>;
}